module.exports = __webpack_public_path__ + "img/wanwu_7.ddf08a14.png";